import { render, staticRenderFns } from "./ReportingProfileReports.vue?vue&type=template&id=539754fd&"
import script from "./ReportingProfileReports.vue?vue&type=script&lang=js&"
export * from "./ReportingProfileReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports